import AccessDenied from "./Includes/AccessDenied";

/**
 * Used as the unauthorized fallback on protected routes.
 * Shows an access message + Home button instead of silently bouncing away.
 */
export default function RoleHomeRedirect() {
  return <AccessDenied />;
}
